import { Button } from '@/components/Button'
import { useModel } from '@/lib/model'
import { providerHealthOf, useHealth, type HealthState } from '@/lib/health'
import type { ProviderId } from '@/types'

interface ModelChipProps {
  onClick?: () => void
}

const TIER_LABEL: Record<ProviderId, string> = {
  anthropic: 'smart',
  codex: 'codex',
  custom: 'router',
  'ollama-cloud': 'cloud',
  'ollama-local': 'local',
}

function dotClassFor(state: HealthState | undefined) {
  switch (state) {
    case 'online':
      return 'health-dot ok'
    case 'degraded':
      return 'health-dot warn'
    case 'offline':
      return 'health-dot down'
    case 'unconfigured':
      return 'health-dot warn'
    default:
      return 'health-dot loading'
  }
}

export function ModelChip({ onClick }: ModelChipProps) {
  const { current } = useModel()
  const { data } = useHealth()
  const health = providerHealthOf(data, current.provider)
  const tier = TIER_LABEL[current.provider]

  return (
    <Button
      variant="chip"
      type="button"
      onClick={onClick}
      title={
        health
          ? `${current.provider}/${current.model} — ${health.state}${health.latency_ms ? ` · ${health.latency_ms}ms` : ''}`
          : `${current.provider}/${current.model}`
      }
    >
      <span className="model-chip-stack" aria-hidden="true">
        <span className="model-chip-dot" />
        <span className="model-chip-dot" />
        <span className="model-chip-dot" />
      </span>
      <span>
        {tier} · <strong>{current.display}</strong>
      </span>
      <span className={dotClassFor(health?.state)} aria-hidden="true" />
    </Button>
  )
}
